import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab957c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-preview" }
const _hoisted_2 = { class: "periodontal-preview__main" }
const _hoisted_3 = { class: "periodontal-preview__header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = { class: "text-bold" }
const _hoisted_7 = { class: "text-bold" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "periodontal-preview__title" }, "Пародонтальная карта", -1))
const _hoisted_10 = { class: "periodontal-preview__survey" }
const _hoisted_11 = { class: "periodontal-preview__survey-date" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Дата обследования", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "ФИО врача", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Должность", -1))
const _hoisted_15 = { class: "periodontal-preview__patient" }
const _hoisted_16 = { class: "periodontal-preview__patient-about" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("ФИО пациента:")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Дата рождения:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Мед карта:")
const _hoisted_20 = {
  key: 0,
  class: "periodontal-preview__comment"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "periodontal-preview__comment-title" }, "Комментарий врача", -1))
const _hoisted_22 = { class: "periodontal-preview__comment-text" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("ФИО врача:")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Должность:")
const _hoisted_25 = { class: "periodontal-preview__footer" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "periodontal-preview__footer-title" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "periodontal-preview__footer-text" }, " Результаты расчета не являются диагнозом или медицинской рекомендацией и не заменяют консультации с врачом. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_periodontal_map = _resolveComponent("periodontal-map")!
  const _component_w_consolidated_report = _resolveComponent("w-consolidated-report")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.logo,
          class: "periodontal-preview__logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.reportInfo.organization?.name), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.reportInfo.organization?.address), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.reportInfo.organization?.phone), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.reportInfo.organization?.site), 1)
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createTextVNode("  " + _toDisplayString(_ctx.date), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _hoisted_13,
            _createTextVNode("  " + _toDisplayString(_ctx.reportInfo.doctor?.name), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_14,
            _createTextVNode("  " + _toDisplayString(_ctx.reportInfo.doctor?.position), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_row, { class: "periodontal-preview__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.surname) + " " + _toDisplayString(_ctx.patientInfo.name) + " " + _toDisplayString(_ctx.patientInfo.patronymic ?? ''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "periodontal-preview__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.birthday), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "periodontal-preview__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.patientInfo.cart_number), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_periodontal_map, {
      data: _ctx.data,
      class: "periodontal-preview__item"
    }, null, 8, ["data"]),
    _createVNode(_component_w_consolidated_report, {
      bleeding: _ctx.bleeding,
      "consolidated-data": _ctx.consolidatedData,
      plaque: _ctx.plaque,
      pockets: _ctx.pockets,
      "pockets-table": _ctx.pocketsTable,
      class: "periodontal-preview__item"
    }, null, 8, ["bleeding", "consolidated-data", "plaque", "pockets", "pockets-table"]),
    (_ctx.lastComment?.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_el_divider),
          _hoisted_21,
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.lastComment?.text), 1),
          _createVNode(_component_el_row, { class: "periodontal-preview__comment-doctor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 3,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 21 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lastComment?.user_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "periodontal-preview__comment-doctor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 3,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 21 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lastComment?.user_position), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createVNode(_component_icon_template, {
        height: "28",
        name: "logo",
        width: "92"
      })
    ])
  ]))
}